<form *ngIf="airSearchForm?.get(eAirSearchFields.price)">
    <div>
        <h2 class="form-title">{{ wording.valueLabel }}</h2>
        <number [fieldConfig]="{
            formGroup: airSearchForm?.get(eAirSearchFields.price),
            formControlName: eAirSearchFields.value,
            min: 0,
            iconDefinition: iconMoney,
            step: 50,
            max: 50000,
            fixed: 0}"
        ></number>
    </div>
    <div>
        <h2 class="form-title">{{ wording.percentageLabel }}</h2>
        <number [fieldConfig]="{
            formGroup: airSearchForm?.get(eAirSearchFields.price).get(eAirSearchFields.plusOrMinus),
            formControlName: eAirSearchFields.percentage,
            min: 0,
            iconDefinition: iconPercent,
            step: 10,
            max: 100,
            fixed: 0}"
        ></number>
    </div>
</form>